<template>
  <AccountCards
    :client-data="clientData || distributorData"
    @update-logo="(data) => updateLogo(data)"
    @update-client="(data) => updateUser(data)"
  ></AccountCards>
</template>

<script>
import { mapState } from 'vuex';
import AccountCards from './AccountCards';
import * as imageConversion from 'image-conversion';

export default {
  name: 'AccountContainer',
  components: {
    AccountCards
  },
  computed: {
    ...mapState({
      clientData: (state) => state.clients.clientData,
      distributorData: (state) => state.distributors.distributorData
    })
  },
  methods: {
    async updateLogo(data) {
      if (this.clientData) {
        const logoClientData = await this.parseObjLogo(this.clientData, data);
        this.$store.dispatch('updateClientLogo', logoClientData);
      } else if (this.distributorData) {
        const logoPartnerData = await this.parseObjLogo(this.distributorData, data);
        this.$store.dispatch('updateDistributorLogo', logoPartnerData);
      }
    },
    updateUser(data) {
      if (this.clientData) {
        this.$store.dispatch('updateClient', data);
      } else if (this.distributorData) {
        this.$store.dispatch('updateDistributor', data);
      }
    },
    async parseObjLogo(data, logoData) {
      return {
        ...logoData,
        body: { logos: data.logos, image: await this.compressLogoImage(logoData.body.logo) }
      };
    },
    async compressLogoImage(base64string) {
      let compressedImage;
      try {
        const base64ImageType = base64string.split(';')[0].split(':')[1] || 'image/png';

        let imageFile = await imageConversion.urltoBlob(base64string);

        imageFile = await imageConversion.compress(imageFile, {
          quality: 0.85,
          height: 800,
          type: base64ImageType
        });

        compressedImage = await imageConversion.filetoDataURL(imageFile);
      } catch (_) {
        compressedImage = base64string;
      }

      return compressedImage;
    }
  }
};
</script>
